/* eslint-disable camelcase */
import { defaults } from 'helpers/cameras/coreCameraProps'

const legacyResolutions = [
  { text: 'QVGA', horizontalResolution: 320, verticalResolution: 240 },
  { text: 'VGA', horizontalResolution: 640, verticalResolution: 480 },
  { text: 'SVGA', horizontalResolution: 800, verticalResolution: 600 },
  { text: '720p', horizontalResolution: 1280, verticalResolution: 720 },
  { text: '1.3MP', horizontalResolution: 1280, verticalResolution: 1024 },
  { text: '2MP', horizontalResolution: 1600, verticalResolution: 1200 },
  { text: '1080p', horizontalResolution: 1920, verticalResolution: 1080 },
  { text: '3MP', horizontalResolution: 2048, verticalResolution: 1536 },
  { text: '4MP', horizontalResolution: 2688, verticalResolution: 1520 },
  { text: '5MP', horizontalResolution: 2592, verticalResolution: 1944 },
  { text: '6MP', horizontalResolution: 3072, verticalResolution: 2048 },
  { text: '4K', horizontalResolution: 3840, verticalResolution: 2160 },
  { text: '10MP', horizontalResolution: 3648, verticalResolution: 2752 },
  { text: '12MP', horizontalResolution: 4000, verticalResolution: 3000 },
  { text: '16MP', horizontalResolution: 4608, verticalResolution: 3456 },
  { text: '6K', horizontalResolution: 6016, verticalResolution: 4008 },
  { text: '7K', horizontalResolution: 7360, verticalResolution: 4128 }
]

const splitAndParseResolution = res => {
  const [h, v] = res.value.split(/x/i)
  return { horizontalResolution: parseFloat(h), verticalResolution: parseFloat(v) }
}

const defaultResolution = {
  horizontalResolution: defaults.horizontalResolution,
  verticalResolution: defaults.verticalResolution
}

export default (resolution, selected_camera_configuration) => {
  if (selected_camera_configuration) {
    const resolution = selected_camera_configuration.resolutions[0]
    return splitAndParseResolution(resolution)
  }

  const legacyRes = legacyResolutions.find(o => o.text === resolution)
  if (!legacyRes) {
    console.log(`RESOLUTION NOT FOUND: ${resolution}`)
    return defaultResolution
  }

  const { horizontalResolution, verticalResolution } = legacyRes
  return { horizontalResolution, verticalResolution }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/resolutions.js